import styled from 'styled-components';
import { H2, Text, ViewSection } from 'ui';
import StyledSlider from './StyledSlider';
import { useSFY } from 'providers/SFYProvider';
import { useLocation } from 'providers';

const clarityValues = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2'];

const Clarity = ({ onTouch }: { onTouch?: () => void }) => {
  const { configuration, defaultConfiguration, updateConfiguration } = useSFY();
  const { translations } = useLocation();

  const handleChange = (range: number | readonly number[]) => {
    const minValue = (range as number[])[0];
    const maxValue = (range as number[])[1];

    const value = clarityValues.slice(minValue, maxValue);

    updateConfiguration &&
      updateConfiguration({
        ...configuration,
        clarity: value,
      });

    onTouch && onTouch();
  };

  const getDefaultValues = () => {
    const savedValues = configuration?.clarity || defaultConfiguration?.clarity;

    return (
      savedValues && [
        clarityValues.findIndex((c) => c === savedValues![0]),
        clarityValues.findIndex((c) => c === savedValues![savedValues!.length - 1]) + 1,
      ]
    );
  };

  return (
    <ViewSection background="white">
      <div className="container py-5 px-4">
        <div className="col-12 col-md-6 mx-auto text-center mb-5">
          <H2 className="mb-4">{translations?.fourC_clarity || 'CLARITY'}</H2>
          <Text className="mb-4">
            {translations?.fourC_clarity_Text ||
              'Inclusions are impurities that naturally occur inside a diamond and affect the quality of the diamond. Diamond clarity is determined by the number of inclusions, their size and position.'}
          </Text>
          {/* <Button variant="underline">{translations?.sfySetting_LearnMore || 'Learn more'}</Button> */}
        </div>
        <div className="row pb-5 py-md-5">
          <div className="col-6 col-md-2 order-2 order-md-1 d-flex align-items-md-center">
            <Text size="s" $monoMedium $uppercase>
              {translations?.sfySetting_clarity_flawless || 'FLAWLESS'}
            </Text>
          </div>
          <div className="col-12 col-md-8 order-1 order-md-2 position-relative">
            <RangeLabelGrid colCount={6}>
              {clarityValues.map((c) => (
                <Text size="s" key={c} $monoMedium $uppercase $center>
                  {c}
                </Text>
              ))}
            </RangeLabelGrid>
            <StyledSlider
              className="horizontal-slider"
              thumbClassName="thumb"
              trackClassName="track--dark track"
              markClassName="marks"
              marks
              defaultValue={getDefaultValues()}
              min={0}
              max={clarityValues.length}
              pearling
              minDistance={1}
              onAfterChange={(value) => handleChange(value)}
            />
          </div>
          <div className="col-6 col-md-2 order-2 order-md-3 d-flex align-items-md-center text-end">
            <Text size="s" $monoMedium $uppercase>
              {translations?.sfySetting_clarity_veryslightinclusions || 'VERY SLIGHT INCLUSIONS'}
            </Text>
          </div>
        </div>
      </div>
    </ViewSection>
  );
};

const RangeLabelGrid = styled.div<{ colCount: number }>`
  position: absolute;
  left: 30px;
  right: 30px;
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: ${({ colCount }) => colCount && `repeat(${colCount}, 1fr)`};
`;

export default Clarity;
